import React, { useState } from "react";
import { Helpers } from "../Helpers";

const ReturnToBooking = ({
  offset = 900,
  scrollToTop = 400,
  totalPrice,
  startingPrice,
  pricingType,
  currency = "US",
  isInCart,
  title = "",
  settings
}) => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > offset) {
      setShowScroll(true);
    }
    if (showScroll && window.pageYOffset <= offset) {
      setShowScroll(false);
    }
  };

  const scrollToBooking = () => {
    window.scrollTo({ top: scrollToTop, behavior: "smooth" });
  };

  let backgroundcolor = _.find(settings, (_setting) => { 
    return _setting.key == 'return_to_booking_topbar_color'; 
  }); 
  
  const styles = { 
    backgroundColor: !_.isEmpty(backgroundcolor) ? backgroundcolor.value : "#FFF", 
    top: "100px", 
    left: 0, 
    zIndex: "9" 
  };

  window.addEventListener("scroll", checkScrollTop);

  if(!showScroll) return null;

  return (
    <div
      className="position-fixed w-100 py-2 shadow-sm" style={styles}
    >
      <div className="container d-flex justify-content-between align-items-center">
        <h4
          class="body-font body-text-color font-weight-bold"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "70%"
          }}
        >
          { title }
        </h4>

        { !isInCart && 
          <div className="d-flex">  
            <div className="mr-3 d-flex align-items-center">
              { totalPrice == 0 ? 
                <React.Fragment>
                  <div
                    className="body-text-color text-uppercase mr-2"
                    style={{ lineHeight: 0.75, fontSize: 12, textAlign: "left" }}
                  >
                    from
                  </div>
                  <div className="d-inline align-items-end">
                    <h4 className="body-font font-weight-bold body-text-color" style={{marginBottom: "-8px"}}>
                      {currency + " " + Helpers.formatNoDecimalCurrency(startingPrice)}
                    </h4>
                    <span
                      className="body-text-color"
                      style={{ lineHeight: 0.75, fontSize: 12 }}
                    >
                      {_.upperCase(pricingType)}
                    </span>
                  </div>
                </React.Fragment> 
                :
                <React.Fragment>
                  <span
                    className="body-text-color text-uppercase mr-2"
                    style={{ fontSize: 12, textAlign: "left" }}
                  >
                    approx.
                  </span>

                  <h4 className="mb-0 body-font d-line font-weight-bold body-text-color">
                    {currency + " " + Helpers.formatNoDecimalCurrency(totalPrice)}
                  </h4>

                </React.Fragment>
              }        
            </div>
            <button
              onClick={scrollToBooking}
              className="btn btn-rounded btn-primary px-5"
            >
              Book
            </button>
          </div>
        }
      </div>
    </div>
  );
};

export default ReturnToBooking;



// WEBPACK FOOTER //
// ./resources/js/components/Shared/ReturnToBooking.js